import * as Yup from 'yup';
import { PropertyPossessionType } from '../enum';


const rentFrequency = Yup.string()
  .when('possessionTypeId', {
    is: PropertyPossessionType.forRent,
    then: Yup.string().required('Rent Frequency is required'),
    otherwise: Yup.string().optional(),
  })
  .label('Rent Frequency');

const advertiseSchema = Yup.object().shape({
  title: Yup.string().required('Title is required.'),
  rentFrequency,
  description: Yup.string().required('Description is required.'),
  // address: Yup.string().required('Address is required.'),
  userId: Yup.string().required('User is required.'),
  price: Yup.number()
    .min(0, "Please enter more than 0")
    .typeError("Must be Number").required('Price is required.'),
  status: Yup.string().required('Status is required.'),
  categoryId: Yup.string().required('Category is required.'),
  attachmentArray: Yup.array()
    .of(Yup.string())
    .min(1, 'Images is required.')
    .required('Images is required.'),
  propertyFacilityIds: Yup.array()
    .min(1, 'Atleast one Property Facility is required.')
    .required('Property Facility is required.'),
  propertyFeatureItems: Yup.array()
    .of(
      Yup.object().shape({
        featureId: Yup.string().required('Property Feature is required.'),
        value: Yup.number()
          .min(0, "Please enter more than 0")
          .typeError("Must be Number").required('Value is required.'),
      })
    )
    .required(),
});

export default advertiseSchema;